<template>
<div class="vm-action-collapse">
    <div @mouseenter="onMouseEnter" @mouseleave="onMouseLeave" ref="tti">
        <svg v-if="!show" height="32" version="1.1" width="32" xmlns="http://www.w3.org/2000/svg" style="transform: scale(0.7);">
            <path d="M16 0C7.2 0 0 7.2 0 16C0 24.8 7.2 32 16 32C24.8 32 32 24.8 32 16C32 7.2 24.8 0 16 0ZM16 29.9C8.3 29.9 2.1 23.7 2.1 16C2.1 8.3 8.3 2.1 16 2.1C23.7 2.1 29.9 8.3 29.9 16C29.9 23.7 23.7 29.9 16 29.9Z"/>
            <path d="M17.2 25.1H14.9C14.8 25.1 14.7 25 14.7 25V22.7C14.7 22.6 14.8 22.6 14.9 22.6H17.2C17.3 22.6 17.3 22.7 17.3 22.7V25L17.2 25.1Z"/>
            <path d="M20 15.7L18.8 16.9C17.9 17.8 17.3 18.6 17.3 20.4C17.3 20.5 17.2 20.6 17.2 20.6H14.7V19.9C14.7 18.5 15.3 17.2 16.2 16.2L17.8 14.6C18.5 13.9 18.8 12.9 18.4 11.9C18.1 11.1 17.4 10.5 16.6 10.3C14.9 9.9 13.4 11.1 13.3 12.7C13.3 12.8 13.2 12.8 13.2 12.8H10.9C10.8 12.8 10.7 12.7 10.7 12.6C10.8 9.8 13.1 7.5 15.9 7.5C17.7 7.5 19.3 8.5 20.2 9.9C21.8 12.1 21.3 14.3 20 15.7Z"/>
        </svg>
        <svg v-if="show" height="32" version="1.1" width="32" xmlns="http://www.w3.org/2000/svg" style="transform: scale(0.7);">
            <path d="M16 0C7.2 0 0 7.2 0 16C0 24.8 7.2 32 16 32C24.8 32 32 24.8 32 16C32 7.2 24.8 0 16 0ZM17.3 25C17.3 25.1 17.2 25.2 17.2 25.2H14.9C14.8 25.2 14.8 25.1 14.8 25V22.7C14.8 22.6 14.9 22.5 14.9 22.5H17.2C17.3 22.5 17.3 22.6 17.3 22.7V25ZM20 15.7L18.8 16.9C17.9 17.8 17.3 18.6 17.3 20.4C17.3 20.5 17.2 20.6 17.2 20.6H14.7V19.9C14.7 18.5 15.3 17.2 16.2 16.2L17.8 14.6C18.5 13.9 18.8 12.9 18.4 11.9C18.1 11.1 17.4 10.5 16.6 10.3C14.9 9.9 13.4 11.1 13.3 12.7C13.3 12.8 13.2 12.8 13.2 12.8H10.9C10.8 12.8 10.7 12.7 10.7 12.6C10.8 9.8 13.1 7.5 15.9 7.5C17.7 7.5 19.3 8.5 20.2 9.9C21.8 12.1 21.3 14.3 20 15.7Z"/>
        </svg>
    </div>
    <div v-if="show" class="vm-tooltip" :style="'margin-left: -' + leftOffset + 'px; width: ' + width + 'px;'">
        <div class="vm-tooltip-content">
            <p v-html="html"></p>
        </div>
    </div>
</div>
</template>
<script>

export default {
name: 'vm-tooltip-action',
props: {
    html: {
        type: String,
        default: ''
    }
},
data() {
    return {
        show: false,
        leftOffset: 100,
        width: 500
    }
},
methods: {
    handleClick(e) {
        this.$emit('input', e.srcElement.value);
    },
    onMouseEnter() {
        //console.log('enter');

        //console.log(this.$refs.tti);

        var element = this.$refs.tti;

        var rect = element.getBoundingClientRect();
        //console.log(rect.top, rect.right, rect.bottom, rect.left);

        this.leftOffset = rect.left - 100;
        this.width = window.innerWidth - 200;
        this.show = true;
    },
    onMouseLeave() {
        //console.log('leave');
        this.show = false;
    }
}
}
</script>
<style scoped>

.vm-action-collapse {
    padding-top: 7px;
    padding-right: 10px;
}

.vm-action-collapse path {
    fill: white;
}

.vm-tooltip {
    position: absolute;
    left: 0px;
    width: 90%;
    min-height: 400px;
    padding: 20px 40px;
    background-color: white;
    z-index: 100;
    border-radius: 5px;
    -webkit-box-shadow: 1px 1px 10px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: 1px 1px 10px 0px rgba(0,0,0,0.75);
    box-shadow: 1px 1px 10px 0px rgba(0,0,0,0.75);
    box-sizing: border-box;
}

</style>
